/* Яндекс Метрика (владелец 02.11.2026, счётчик 113999624). Только собранное приложение: в vite dev, проверках и демо счётчика нет.
   Номер — window.__config__.METRIKA_ID из runtime-конфига (/env.js, у кластера — ConfigMap): число — свой счётчик, '' / 0 / false — выключено;
   ключа нет — счётчик по умолчанию.
   Адрес — без данных Telegram: Mini App открывается с #tgWebAppData=… (подписанные данные пользователя — по сути ключ входа) и
   tgWebApp* в query; в Метрику они не уходят ни при старте, ни с переходами, ни в метках вебвизора. Разделы — адресом #раздел: смена хэша
   (#studio, #balance…) — просмотр страницы (hit), сам счётчик хэш не отслеживает */
const DEFAULT_ID = 113999624;
const TAG = 'https://mc.yandex.ru/metrika/tag.js';

type Ym = ((id: number, method: string, ...args: unknown[]) => void) & { a?: unknown[][]; l?: number };
declare global {
  interface Window {
    ym?: Ym;
    __config__?: { METRIKA_ID?: number | string | boolean | null };
  }
}

/** Номер счётчика из runtime-конфига: нет ключа — по умолчанию, пусто или 0 — выключено */
export function metrikaId(config: Window['__config__'] = window.__config__): number | null {
  if (!config || !('METRIKA_ID' in config)) return DEFAULT_ID;
  const n = Number(config.METRIKA_ID);
  return Number.isSafeInteger(n) && n > 0 ? n : null;
}

/** Адрес для Метрики: без tgWebApp* в query и без данных Telegram в хэше; остаётся только раздел (#studio) */
export function metrikaUrl(href: string): string {
  const url = new URL(href);
  for (const key of [...url.searchParams.keys()]) if (/^tgWebApp/i.test(key)) url.searchParams.delete(key);
  const hash = url.hash.replace(/^#/, '');
  const section = /^[a-z][a-z0-9_-]*/i.exec(hash)?.[0] ?? '';
  url.hash = section && !/^tgWebApp/i.test(section) ? section : '';
  return url.toString();
}

export function installMetrika() {
  if (import.meta.env.DEV || import.meta.env.MODE === 'test') return;
  const id = metrikaId();
  if (!id || window.ym) return;
  const ym: Ym = (...args: [number, string, ...unknown[]]) => {
    (ym.a = ym.a || []).push(args);
  };
  ym.l = Date.now();
  window.ym = ym;
  const script = document.createElement('script');
  script.async = true;
  script.src = `${TAG}?id=${id}`;
  document.head.append(script);
  let last = metrikaUrl(location.href);
  ym(id, 'init', {
    defer: true,
    webvisor: true,
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    trackHash: false,
    ecommerce: 'dataLayer',
    url: last,
    referrer: document.referrer,
  });
  ym(id, 'hit', last, { title: document.title, referer: document.referrer });
  window.addEventListener('hashchange', () => {
    const next = metrikaUrl(location.href);
    if (next === last) return;
    ym(id, 'hit', next, { title: document.title, referer: last });
    last = next;
  });
}
